var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-d-loader__container",class:{ 'r-d-loader__container--overlay': _vm.overlay }},[_c('img',{staticClass:"r-d-loader__svg",attrs:{"src":"/images/shared/Robins-And-Day-Loader-Purple.svg","alt":"Loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }